class WishlistManager {
  constructor() {
    this.STORAGE_KEY = 'shopify-wishlist';
    
    // MODIFIED: Select both types of buttons
    this.buttons = document.querySelectorAll('.wishlist-btn, .mp-wishlist-btn');
    
    // 1. Initialize immediately
    this.init();
    
    // 2. Listen for external updates
    document.addEventListener('wishlist:updated', () => {
      this.updateButtons();
      this.updateHeaderCount();
    });

    // 3. SPECIAL FIX: Re-check header count after a short delay 
    setTimeout(() => this.updateHeaderCount(), 500);
    setTimeout(() => this.updateHeaderCount(), 2000);
  }

  init() {
    // Event delegation for better performance and dynamic content
    document.addEventListener('click', (e) => {
      // MODIFIED: Check for both classes
      const btn = e.target.closest('.wishlist-btn, .mp-wishlist-btn');
      if (!btn) return;
      
      e.preventDefault();
      e.stopPropagation(); 
      const handle = btn.dataset.productHandle;
      this.toggle(handle, btn);
    });
    
    this.updateButtons();
    this.updateHeaderCount();
  }

  getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(this.STORAGE_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  toggle(handle, btn) {
    let wishlist = this.getWishlist();
    const index = wishlist.indexOf(handle);

    if (index === -1) {
      // Add
      wishlist.push(handle);
      
      // Update the specific button clicked immediately for instant feedback
      btn.classList.add('is-active');
      
      // Animation
      btn.style.transform = 'scale(1.3)';
      setTimeout(() => btn.style.transform = '', 200);
    } else {
      // Remove
      wishlist.splice(index, 1);
      btn.classList.remove('is-active');
    }

    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(wishlist));
    
    // Update UI (Syncs all other buttons on the page)
    document.dispatchEvent(new CustomEvent('wishlist:updated'));
    
    // Handle Wishlist Page logic
    if(window.location.pathname.includes('wishlist') && index !== -1) {
       const card = btn.closest('.product-card') || btn.closest('.grid__item') || btn.closest('.wishlist-product-wrapper');
       if(card) card.remove();
       
       if(wishlist.length === 0) {
         const grid = document.getElementById('WishlistGrid');
         const empty = document.getElementById('WishlistEmpty');
         if(grid) grid.style.display = 'none';
         if(empty) empty.style.display = 'block';
       }
    }
  }

  updateButtons() {
    const wishlist = this.getWishlist();
    
    // MODIFIED: Find all buttons of both types
    const buttons = document.querySelectorAll('.wishlist-btn, .mp-wishlist-btn');
    
    buttons.forEach(btn => {
      const handle = btn.dataset.productHandle;
      if (wishlist.includes(handle)) {
        btn.classList.add('is-active');
      } else {
        btn.classList.remove('is-active');
      }
    });
  }

  updateHeaderCount() {
    const wishlist = this.getWishlist();
    const count = wishlist.length;
    const badge = document.getElementById('WishlistCount');

    if (badge) {
      badge.textContent = count;
      
      if (count > 0) {
        badge.style.display = 'flex'; 
        badge.removeAttribute('hidden');
      } else {
        badge.style.display = 'none';
        badge.setAttribute('hidden', '');
      }
    }
  }
}

// Initialize
document.addEventListener('DOMContentLoaded', () => {
  window.wishlistManager = new WishlistManager();
});